<template>
  <div class="mt-3">
    <div :class="{ 'has-crossprice': hasCrossPrice }">
      <span class="price h1 d-inline-block pr-3">
        {{ variationTotalPrice | currency(variation.prices.default.currency) }}
      </span>

      <span class="vat small">
        {{ isExportDelivery ? '' : $translate("Ceres::Template.singleItemInclVAT") }}
        <template v-if="!hasFreeShipping">
          {{ $translate("Ceres::Template.singleItemExclusive") }}
          <a
            data-toggle="modal"
            href="#shippingscosts"
            :title="$translate('Ceres::Template.singleItemShippingCosts')"
          >{{ $translate('Ceres::Template.singleItemShippingCosts') }}</a>
        </template>
      </span>
    </div>
    <div
      v-if="hasCrossPrice"
      class="crossprice d-flex"
    >
      {{ $translate("modeherz::SingleItemPageClient.itemPageRRP") }}:
      <del class="pl-1">
        {{ variation.prices.rrp.unitPrice.formatted | itemCrossPrice }}
      </del>
      <div
        class="calculated"
      >
        &nbsp;/&nbsp;<b>{{ $translate("modeherz::SingleItemPageClient.itemPagePriceYouSave") }} </b><span> - {{ youSaveAmountText }}
        </span>
      </div>
    </div>
      <div class="lowest-price text-muted mb-3" v-if="variation.prices.default.lowestPrice && variation.prices.default.lowestPrice.value && hasCrossPrice && displayLowestPrice">
          <div v-html="$translate('Ceres::Template.singleItemLowestPrice', {'price': variation.prices.default.lowestPrice.formatted})">
          </div>
      </div>
  </div>
</template>

<script>
import isCrossPrice from '../../helpers/is-cross-price'
export default {
    name: 'VariationPrice',
    props: {
        variation: {
            type: Object,
            required: true
        },
        minimumAbsoluteValue: {
            type: Number,
            default: 0.5
        },
        minimumPercentageValue: {
            type: Number,
            default: 5
        },
        hasFreeShipping: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasCrossPrice () {
            return this.isCrossPrice(this.variation, { minimumPercentageValue: this.minimumPercentageValue, minimumAbsoluteValue: this.minimumAbsoluteValue })
        },
        displayLowestPrice(){
          return App.modeherzPluginConfig.prices.crossPrice.displayLowestPrice
        },
        isExportDelivery(){
          return this.$store.state.basket && this.$store.state.basket.data && this.$store.state.basket.data.isExportDelivery
        },
        variationTotalPrice () {
            return this.$store.getters[`${this.variation.item.id}/variationTotalPrice`]
        },
        totalAmountSaved () {
            return Math.round((this.variation.prices.rrp.unitPrice?.value - this.variation.prices.default.price?.value) * 10000) / 10000.0
        },
        percentageAmountSaved () {
            const percent = Math.round(((1 - (this.variation.prices.default.price?.value / this.variation.prices.rrp.unitPrice?.value)) * 100000)) / 1000.0
            return percent > 1 ? Math.floor(percent) : percent
        },
        displayPercentage () {
            return this.percentageAmountSaved >= 1
        },
        youSaveAmountText () {
            const totalAmountSave = this.$options.filters.currency(this.totalAmountSaved, this.variation.prices.default.currency)
            if (this.displayPercentage) {
                return `${this.percentageAmountSaved}% ( ${totalAmountSave} )`
            }
            return `${totalAmountSave}`
        }
    },
    methods: {
        isCrossPrice
    }
}
</script>

<style scoped>

</style>
